import clsx from 'clsx'
import React, { FC } from 'react'
import classes from './title.module.css'

interface TitleProps {
  id?: string
  text: string
  className?: string
  level?: 'h1' | 'h2' | 'h3'
  sub?: React.ReactNode
}

export const Title: FC<TitleProps> = (props) => {
  switch (props.level) {
    case 'h1':
      return <H1 {...props} />
    case 'h2':
      return <H2 {...props} />
    case 'h3':
      return <H3 {...props} />
    default:
      return <H1 {...props} />
  }
}

const H1: FC<TitleProps> = ({ id, text, className, sub, children }) => {
  const cn = clsx(classes.h1, className, sub && classes.subWrap)
  return (
    <h1 id={id} className={cn}>
      <div>{text}</div>
      {sub && <div className={classes.sub}>{sub}</div>}
      {children}
    </h1>
  )
}

const H2: FC<TitleProps> = ({ id, text, className, sub, children }) => {
  const cn = clsx(classes.h2, className, sub && classes.subWrap)
  return (
    <h2 id={id} className={cn}>
      <div>{text}</div>
      {sub && <div className={classes.sub}>{sub}</div>}
      {children}
    </h2>
  )
}

const H3: FC<TitleProps> = ({ id, text, className, sub, children }) => {
  const cn = clsx(classes.h3, className, sub && classes.subWrap)
  return (
    <h3 id={id} className={cn}>
      <div>{text}</div>
      {sub && <div className={classes.sub}>{sub}</div>}
      {children}
    </h3>
  )
}
